import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex flex-col items-center justify-center flex-1 px-6 text-center"
};
const _hoisted_2 = { class: "text-[18px] font-semibold text-[#374151]" };
const _hoisted_3 = { class: "text-[14px] text-[#9CA3AF] mt-1 max-w-[320px]" };
import { computed } from "vue";
import { IconMessage2Off } from "@tabler/icons-vue";
import { getLoginUserId } from "@/plugins/shared";
import { useAuthStore } from "@/domains/auth";
import ConversationHeader from "./ConversationHeader.vue";
import MessageList from "./MessageList.vue";
import MessageInput from "./MessageInput.vue";
import ClosedBanner from "./ClosedBanner.vue";
import { useConversation } from "../composables/useConversation";
import { useConversationStore } from "../stores";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationPanel',
    props: {
        conversationId: {},
        showBack: { type: Boolean }
    },
    emits: ["back"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const authStore = useAuthStore();
        const conversationStore = useConversationStore();
        const { conversation, messages, isLoading, isSubmitting, isClosed, sendMessage, closeConversation, editMessage, deleteMessage, } = useConversation({ conversationId: () => props.conversationId });
        const currentUserId = computed(() => String(getLoginUserId()));
        const currentOrgId = computed(() => String(authStore.currentOrgId ?? ""));
        let lastReadInteractionAt = 0;
        async function handleSend(payload) {
            await sendMessage(payload);
        }
        async function handleClose() {
            await closeConversation();
        }
        async function handleEdit(messageId, text) {
            await editMessage(messageId, text);
        }
        async function handleDelete(messageId) {
            await deleteMessage(messageId);
        }
        function handleReaderInteraction() {
            if (!props.conversationId || !conversation.value)
                return;
            const now = Date.now();
            conversationStore.noteChatReaderInteraction();
            if (now - lastReadInteractionAt < 5000)
                return;
            lastReadInteractionAt = now;
            void conversationStore.markMessageNotificationsRead(props.conversationId);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col h-full",
                style: { "background-color": "#f5f6fa" },
                onPointermovePassive: handleReaderInteraction,
                onFocusin: handleReaderInteraction,
                onClick: handleReaderInteraction,
                onKeydownCapture: handleReaderInteraction
            }, [
                (!_unref(conversation))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_unref(IconMessage2Off), { class: "w-16 h-16 mb-4 text-gray-300" }),
                        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("conversation.auto.selecciona_una_conversacion")), 1),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("conversation.auto.elige_una_conversacion_de_la_lista_para_comenzar")), 1)
                    ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(ConversationHeader, {
                            conversation: _unref(conversation),
                            "show-back": __props.showBack,
                            "is-closing": _unref(isSubmitting),
                            onClose: handleClose,
                            onBack: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('back')))
                        }, null, 8, ["conversation", "show-back", "is-closing"]),
                        _createVNode(MessageList, {
                            messages: _unref(messages),
                            "current-user-id": currentUserId.value,
                            "current-org-id": currentOrgId.value,
                            "is-loading": _unref(isLoading),
                            "is-closed": _unref(isClosed),
                            "is-submitting": _unref(isSubmitting),
                            class: "flex-1",
                            onEdit: handleEdit,
                            onDelete: handleDelete
                        }, null, 8, ["messages", "current-user-id", "current-org-id", "is-loading", "is-closed", "is-submitting"]),
                        (_unref(isClosed))
                            ? (_openBlock(), _createBlock(ClosedBanner, {
                                key: 0,
                                reason: _unref(conversation).closure_reason
                            }, null, 8, ["reason"]))
                            : (_openBlock(), _createBlock(MessageInput, {
                                key: 1,
                                disabled: _unref(isClosed),
                                "is-submitting": _unref(isSubmitting),
                                onSend: handleSend
                            }, null, 8, ["disabled", "is-submitting"]))
                    ], 64))
            ], 32));
        };
    }
});
